import { atom, useAtom } from 'jotai';

const JobHistoryExpandedState = atom({
  amzn1: false,
  amzn2: false,
  appliedConcepts: false,
  bensonIntern: false,
});

export const useJobHistoryExpandedState = () => {
  const [state, setState] = useAtom(JobHistoryExpandedState);

  const toggleJob = (job: keyof typeof state) => {
    setState((prevState) => ({
      ...prevState,
      [job]: !prevState[job],
    }));
  };

  return {
    state,
    toggleJob,
  };
};
